import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory, useLocation } from "react-router";
import Modal from "theme/components/organisms/Modal";
import useRefreshing from "theme/modules/Router/useRefreshing";
import PublishProductReview, {
  addReviewAnchorId,
  hasPublishProductReview,
} from "./";

export { hasPublishProductReview };

const usePublishProductReviewModal = (product) => {
  const history = useHistory();
  const location = useLocation();

  const isActiveHash = location.hash === `#${addReviewAnchorId}`;

  const [needsReloadOnDone, setNeedsReloadOnDone] = useState();
  const [isOpen, setOpened] = useState(isActiveHash);
  const [, setRefreshing] = useRefreshing();

  useEffect(() => {
    if (!isOpen && isActiveHash) {
      setOpened(true);
    }
  }, [isOpen, setOpened, isActiveHash]);

  const onClose = () => {
    history.replace({
      ...location,
      hash: "",
    });
    if (needsReloadOnDone) {
      setRefreshing(true);
      window.location.href = window.location.href.replace(/#.*$/, "");
    } else {
      setOpened(false);
    }
  };

  const modal = (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={
        <FormattedMessage
          id="modules.Reviews.PublishProductReview.title"
          defaultMessage="Write a review for: {productName}"
          values={{ productName: product.name }}
        />
      }
    >
      <PublishProductReview
        product={product}
        setNeedsReloadOnDone={setNeedsReloadOnDone}
      />
    </Modal>
  );

  return [modal];
};

export default usePublishProductReviewModal;
